import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../components/Layout/Layout.vue';
import Registration from '../components/Registrations/Registration.vue';
import RegistrationWrapper from '../components/Registrations/RegistrationWrapper.vue';
// import AddRecord from '../components/Registrations/AddRecord.vue';
import AddRecordFlow from '../components/Registrations/AddRecordFlow.vue';
import ProvideEvidence from '../components/Registrations/ProvideEvidence.vue';
// import DefaultULReview from '../components/Common/DefaultULReview.vue';
import Notification from '../components/Notification/Notification.vue';
import AccountsTable from '../components/SuperAdmin/AccountsTable.vue';
import Email from '../components/Email/Email.vue';
import Dashboard from '../components/Dashboard/NewDashboard.vue';
import MarketPlaceView from '../components/MarketPlace/MarketPlaceView.vue';
import MarketPlace from '../components/MarketPlace/MarketPlace.vue';
import ProductCompliance from '../components/MarketPlace/ProductCompliance.vue';
import FreeResources from '../components/MarketPlace/FreeResources.vue';
import Tools from '../components/Tools/Tools.vue';
import Classification from '../components/Tools/Classification.vue';
import LaunchPad from '../components/LaunchPad/LaunchPad.vue';
// import RepresentationResources from '../components/RepresentationResources/RepresentationResources.vue';
import ServiceProviders from '../components/RepresentationResources/ServiceProviders.vue';
import Login from '../components/Login/Login.vue';
import TermsOfService from '../components/TermsOfService/TermsOfService.vue';
import Register from '../components/Register/Register.vue';
import LandingLayout from '../components/LandingLayout/Layout.vue';
import ForgotPassword from '../components/Password/ForgotPassword.vue';
import ResetPassword from '../components/Password/ResetPassword.vue';
import ConfirmRegister from '../components/Register/ConfirmRegister.vue';
import ConfirmLogin from '../components/Login/ConfirmLogin.vue';
import PermissionAccess from '../components/Common/PermissionAccess.vue';
import RAMSTour from '../components/VirtualTour/RAMSTour.vue';
import VerificationLink from '../components/VerificationLink/VerificationLink.vue';
import ContactUS from '../components/Layout/ContactUS.vue';
import MarketNews from '../components/MarketNews/MarketNewsLayout.vue';
import ManageCompliance from '../components/Registrations/NewManageCompliance.vue';
import RegulationsCheck from '../components/Registrations/RegulationCheck.vue';
import ViewCart from '../components/MarketPlace/ViewCart.vue';
import AccountSettings from '../components/ProfileAccountSettings/AccountSettings.vue';
import PaymentTerms from '../components/Login/PaymentTerms.vue';
import PrivacyNotice from '../components/Login/PrivacyNotice.vue';
import TermsAndConditions from '../components/Login/TermsAndConditions.vue';
import PaymentTermsPortuguese from '../components/Login/PaymentTermsPortuguese.vue';
import PrivacyNoticePortuguese from '../components/Login/PrivacyNoticePortuguese.vue';
import TermsAndConditionsPortuguese from '../components/Login/TermsAndConditionsPortuguese.vue';
import ULStepperTabs from '../components/Common/ULStepperTabs.vue';
import ViewDetails from '../components/Registrations/ViewRecord.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: LandingLayout,
      name: 'landinglayout',
      children: [
        {
          path: 'login',
          component: Login,
          name: 'login',
          meta: {
            title: 'Login',
          },
        },
        {
          path: 'confirmlogin/:token',
          component: ConfirmLogin,
          name: 'confirmlogin',
          meta: {
            title: 'Confirm Login',
          },
        },
        {
          path: 'register',
          component: Register,
          name: 'register',
          meta: {
            title: 'Register',
          },
        },
        {
          path: 'forgot',
          component: ForgotPassword,
          name: 'forgot',
          props: true,
          meta: {
            title: 'Forgot Password',
          },
        },
        {
          path: 'verificationlink',
          component: VerificationLink,
          name: 'VerificationLink',
          props: true,
          meta: {
            title: 'Verfication Link',
          },
        },
        {
          path: 'reset/:token',
          component: ResetPassword,
          name: 'confirmreset',
          props: true,
          meta: {
            title: 'Reset Password',
          },
        },
        {
          path: 'register/:token',
          component: ConfirmRegister,
          name: 'confirmregister',
          props: true,
          meta: {
            title: 'Confirm Register',
          },
        },
        {
          path: '/terms-of-service',
          component: TermsOfService,
          name: 'termsofservice',
          props: true,
          meta: {
            title: 'Terms Of Service',
          },
        },
      ],
    },
    {
      path: '/rams-tour',
      name: 'RAMSTour',
      component: RAMSTour,
      props: true,
      meta: {
        title: 'RAMSTour',
      },
    },
    {
      path: '/payment-terms',
      name: 'PaymentTerms',
      component: PaymentTerms,
      props: true,
      meta: {
        title: 'PaymentTerms',
      },
    },
    {
      path: '/privacy-notice',
      name: 'PrivacyNotice',
      component: PrivacyNotice,
      props: true,
      meta: {
        title: 'PrivacyNotice',
      },
    },
    {
      path: '/terms-conditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions,
      props: true,
      meta: {
        title: 'TermsAndConditions',
      },
    },
    {
      path: '/payment-terms-portuguese',
      name: 'PaymentTermsPortuguese',
      component: PaymentTermsPortuguese,
      props: true,
      meta: {
        title: 'PaymentTerms',
      },
    },
    {
      path: '/privacy-notice-portuguese',
      name: 'PrivacyNoticePortuguese',
      component: PrivacyNoticePortuguese,
      props: true,
      meta: {
        title: 'PrivacyNotice',
      },
    },
    {
      path: '/terms-conditions-portuguese',
      name: 'TermsAndConditionsPortuguese',
      component: TermsAndConditionsPortuguese,
      props: true,
      meta: {
        title: 'TermsAndConditions',
      },
    },
    {
      path: '/layout',
      component: Layout,
      name: 'Layout',
      redirect: '/layout/dashboard',
      meta: {
        title: 'Dashboard',
      },
      children: [
        {
          path: 'dashboard',
          component: Dashboard,
          name: 'Dashboard',
          props: true,
          meta: {
            title: 'Dashboard',
          },
        },
        {
          path: 'market-place',
          component: MarketPlaceView,
          props: true,
          children: [
            {
              path: '/',
              name: 'Marketplace',
              component: MarketPlace,
              props: true,
              meta: {
                title: 'Marketplace',
              },
            },
            {
              path: 'product-compliance',
              name: 'productCompliance',
              component: ProductCompliance,
              meta: {
                title: 'Marketplace',
              },
            },
            {
              path: 'resources',
              name: 'FreeResources',
              component: FreeResources,
              meta: {
                title: 'Marketplace',
              },
            },
          ],
        },
        {
          path: 'registration',
          component: RegistrationWrapper,
          props: true,
          meta: {
            title: 'Complaince Tracker',
          },
          children: [
            {
              path: '/',
              component: Registration,
              name: 'Registration',
              props: true,
              meta: {
                title: 'Compliance Tracker',
              },
            },
            {
              path: 'flow',
              component: ULStepperTabs,
              name: 'ULStepperTabs',
              props: true,
              meta: {
                title: 'Compliance Tracker',
              },
              children: [
                {
                  path: 'add-record',
                  name: 'AddRecord',
                  component: AddRecordFlow,
                  props: true,
                  meta: {
                    title: 'Compliance Tracker',
                  },
                },
                {
                  path: 'add-record/:id',
                  name: 'Add Record',
                  component: AddRecordFlow,
                  props: true,
                  meta: {
                    title: 'Compliance Tracker',
                  },
                },
                {
                  path: 'regulation-check/:type_id/:id',
                  name: 'RegulationsCheck',
                  component: RegulationsCheck,
                  props: true,
                  meta: {
                    title: 'Compliance Tracker',
                  },
                },
                {
                  path: 'provide-evidence/:id',
                  name: 'Provide Evidence',
                  component: ProvideEvidence,
                  props: true,
                  meta: {
                    title: 'Compliance Tracker',
                  },
                },
                {
                  path: 'final-review/:id',
                  name: 'Final Review',
                  component: ViewDetails,
                  props: true,
                  meta: {
                    title: 'Compliance Tracker',
                  },
                }
              ]
            },
            {
              path: 'add-record',
              name: 'AddRecord',
              component: AddRecordFlow,
              props: true,
              meta: {
                title: 'Compliance Tracker',
              },
            },
            {
              path: 'add-record/:id',
              name: 'Add Record',
              component: AddRecordFlow,
              props: true,
              meta: {
                title: 'Compliance Tracker',
              },
            },
          ],
        },
        {
          path: 'manage-compliance',
          name: 'ManageCompliance',
          component: ManageCompliance,
          props: true,
          meta: {
            title: 'Compliance Tracker',
          },
        },
        {
          path: 'view-record/:id',
          name: 'View Record',
          component: ViewDetails,
          props: true,
          meta: {
            title: 'Compliance Tracker',
          },
        },
        {
          path: 'headlines',
          component: MarketNews,
          name: 'Headlines',
          props: true,
          meta: {
            title: 'Headlines',
          },
        },
        {
          path: 'email/:mode/:id',
          component: Email,
        },
        {
          path: 'alert',
          name: 'notification',
          component: Notification,
          meta: {
            title: 'Notifications',
          },
        },
        {
          path: 'super-admin',
          name: 'superAdmin',
          component: AccountsTable,
          meta: {
            title: 'Launchpad',
          },
        },
        {
          path: 'tools',
          component: Tools,
          children: [
            {
              path: 'classification',
              name: 'Classification',
              component: Classification,
              meta: {
                title: 'Resources',
              },
            },
          ],
        },
        {
          path: 'representationresources',
          component: ServiceProviders,
          name: 'RepresentationResources',
          meta: {
            title: 'Resources',
          },
        },
        {
          path: 'launchpad',
          component: LaunchPad,
          name: 'LaunchPad',
          redirect: '/layout/launchpad',
          meta: {
            title: 'Launch Pad',
          },
        },
        {
          path: 'PermissionAccess',
          component: PermissionAccess,
          name: 'PermissionsAccess',
          props: true,
          meta: {
            title: 'Permission Access',
          },
        },
        {
          path: 'support',
          component: ContactUS,
          name: 'support',
          props: true,
          meta: {
            title: 'Help & Support',
          },
        },
        {
          path: 'viewCart',
          component: ViewCart,
          name: 'ViewCart',
          props: true,
          meta: {
            title: 'Help & Support',
          },
        },
        {
          path: 'account-settings',
          component: AccountSettings,
          name: 'Account Settings',
          props: true,
          meta: {
            title: 'Account Settings',
          },
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
